import { Link } from 'react-router-dom';
import { Plane, Truck, Package, Car, Warehouse, Send } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';

/**
 * Single entry point for the whole Logistics & Travel module - per
 * the same explicit direction already applied to Partner Due
 * Diligence, this stays ONE sidebar link even as more areas
 * (Logistics Requests, Assets, Fleet, Warehouses) get their frontend
 * built out; each new area becomes a card here rather than its own
 * sidebar entry.
 */
export function LogisticsTravelHubPage() {
  const cards = [
    { to: '/logistics/requests', icon: Truck, title: 'Logistics Requests', description: 'Request and track operational support - vehicles, equipment, supplies, and movement of goods.' },
    { to: '/logistics/assets', icon: Package, title: 'Asset Register', description: 'Track organizational assets - custody, movement, and disposal.' },
    { to: '/logistics/fleet', icon: Car, title: 'Fleet / Vehicles', description: 'Vehicle register, dispatch and trip logs, fuel consumption, and maintenance.' },
    { to: '/logistics/warehouses', icon: Warehouse, title: 'Warehouses / Inventory', description: 'Warehouse register, stock levels, goods receipt, and stock requests.' },
    { to: '/logistics/waybills', icon: Send, title: 'Dispatch / Waybills', description: 'Track goods dispatch and delivery, with proof-of-delivery confirmation.' },
    { to: '/travel', icon: Plane, title: 'Travel', description: 'Request, approve, and authorize staff travel - itinerary, arrangements, advances, expenses, and reconciliation.' },
  ];

  return (
    <div className="page">
      <PageHeader title="Logistics & Travel" description="Operational logistics and staff travel management." />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
        {cards.map((c) => (
          <Link key={c.to} to={c.to} className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
            <c.icon size={28} style={{ marginBottom: 8 }} />
            <h3>{c.title}</h3>
            <p className="muted">{c.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
